import { RendererFactory2 } from '@angular/core';
import { environment } from '../../../../../environments/environment';

export const hotJarFactory = (rendererFactory: RendererFactory2) => {
  return () => {
    const hotJarId = environment.hotJarId;
    if (!hotJarId) {
      return;
    }

    const renderer = rendererFactory.createRenderer(null, null);
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.text = `
      (function(h,o,t,j,a,r){
          h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
          h._hjSettings={hjid:${hotJarId},hjsv:6};
          a=o.getElementsByTagName('head')[0];
          r=o.createElement('script');r.async=1;
          r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
          a.appendChild(r);
      })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
    `;
    renderer.appendChild(document.head, script);
  };
};
